export * from './cookie-service/cookie.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-cookie-service/index.js
// module id = ./node_modules/ngx-cookie-service/index.js
// module chunks = vendor